"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrderVersion = exports.Build = exports.Kind = exports.normalizeSize = exports.Size = exports.NAMESPACE = void 0;
const effect_1 = require("effect");
const date_1 = require("../../date");
const entity_1 = require("../../entity");
const SemVer = __importStar(require("../../semver"));
const user_1 = require("../user");
const common_1 = require("./class/common");
exports.NAMESPACE = 'Culligan.Device.Ota';
exports.Size = effect_1.Schema.Int.pipe(effect_1.Schema.nonNegative()).annotations({
    identifier: `${exports.NAMESPACE}.Size`,
    description: 'The size of a device firmware build expressed in bytes.',
});
exports.normalizeSize = effect_1.Match.type().pipe(effect_1.Match.withReturnType(), effect_1.Match.when(effect_1.Number.lessThan(Math.pow(10, 3)), bytes => [bytes, 'B']), effect_1.Match.when(effect_1.Number.lessThan(Math.pow(10, 6)), bytes => [bytes / Math.pow(10, 3), 'kB']), effect_1.Match.when(effect_1.Number.lessThan(Math.pow(10, 9)), bytes => [bytes / Math.pow(10, 6), 'MB']), effect_1.Match.when(effect_1.Number.lessThan(Math.pow(10, 12)), bytes => [bytes / Math.pow(10, 9), 'GB']), effect_1.Match.orElse(bytes => [bytes / Math.pow(10, 12), 'TB']));
exports.Kind = effect_1.Schema.Literal('PrimaryFirmware', 'PowerBoardFirmware', 'Screensaver', 'Script').annotations({ identifier: `${exports.NAMESPACE}.Kind` });
exports.Build = effect_1.Schema.Struct({
    ...entity_1.BaseTimestampedEntity.fields,
    id: effect_1.Schema.NonEmptyString,
    buildFile: effect_1.Schema.propertySignature(effect_1.Schema.NonEmptyString).annotations({
        description: 'HTTPS URL to download the file artifact',
    }),
    model: effect_1.Schema.propertySignature(common_1.ModelCode).annotations({
        description: 'Device model that this Build is compatible with',
    }),
    kind: effect_1.Schema.optionalWith(exports.Kind, { exact: true }).annotations({
        description: 'The kind of file artifact, if specified',
    }),
    version: effect_1.Schema.propertySignature(SemVer.SemVer).annotations({
        description: 'SemVer-compliant version of this Build',
    }),
    minVersion: effect_1.Schema.propertySignature(effect_1.Schema.NullOr(SemVer.SemVer)).annotations({
        description: 'The minimum Build version on the device that would support utilizing this Build, if such a constraint exists',
    }),
    enabled: effect_1.Schema.propertySignature(effect_1.Schema.Boolean).annotations({
        description: 'Whether this Build is selectable',
    }),
    description: effect_1.Schema.propertySignature(effect_1.Schema.NullOr(effect_1.Schema.String)),
    userId: effect_1.Schema.propertySignature(user_1.Id).annotations({
        description: 'The ID of the user who uploaded the Build, recorded for auditing purposes',
    }),
    timestamp: effect_1.Schema.propertySignature(date_1.Timestamp).annotations({
        description: 'The date and time this Build was created',
    }),
    size: effect_1.Schema.propertySignature(exports.Size).annotations({
        description: "The filesize of this Build's file artifact expressed in bytes",
    }),
}).annotations({
    identifier: `${exports.NAMESPACE}.Build`,
    description: 'A device Build artifact to be deployed via OTA update jobs.',
});
exports.OrderVersion = effect_1.Order.mapInput(SemVer.Order, effect_1.Struct.get('version'));
//# sourceMappingURL=ota.js.map